import type {FacetChildUiModel, FacetTreeUiModel} from '../../../../models/ui/facets/facet-tree-ui.model';

export function refactorTreeByDividerFacets(facets: FacetTreeUiModel[], dividerMobileFacets: string[]): {outerFacets: FacetChildUiModel[], filteredFacets: FacetTreeUiModel[]} {
    let filteredFacets: FacetTreeUiModel[] = [];
    const outerFacets: FacetChildUiModel[] = [];
    filteredFacets = facets.filter((facet) => {
        if(dividerMobileFacets.some(facetId => facetId === facet.id)) {
          facet.children.forEach((fch) => {
              outerFacets.push(fch as FacetChildUiModel);
          });

          return false;
        }
        return true;
    });

    return {outerFacets, filteredFacets};
}
